var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "vcenter" }, [
    _c(
      "form",
      {
        staticClass: "vcenter-form",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.login($event)
          }
        }
      },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("login.title")))]),
        _vm.errorMessage
          ? _c("b-message", { attrs: { type: "is-danger" } }, [
              _vm._v(_vm._s(_vm.errorMessage))
            ])
          : _vm._e(),
        _c(
          "b-field",
          { attrs: { label: _vm.$t("login.field-login") } },
          [
            _c("b-input", {
              attrs: { type: "email" },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            })
          ],
          1
        ),
        _c(
          "b-field",
          { attrs: { label: _vm.$t("login.field-password") } },
          [
            _c("b-input", {
              attrs: { type: "password" },
              model: {
                value: _vm.password,
                callback: function($$v) {
                  _vm.password = $$v
                },
                expression: "password"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "form-buttons" }, [
          _c(
            "button",
            { staticClass: "button is-primary", attrs: { type: "submit" } },
            [_vm._v(_vm._s(_vm.$t("login.btn-valider")))]
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c(
                "router-link",
                { staticClass: "small", attrs: { to: "/password-reset" } },
                [_vm._v(_vm._s(_vm.$t("login.btn-reset")))]
              )
            ],
            1
          )
        ]),
        _c("b-loading", {
          attrs: { active: _vm.loading, "is-full-page": false }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }